import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="forgot-password-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm bg-[#0a0a0a] border border-white/10 rounded-2xl p-8">
        {sent ? (
          <div className="text-center" data-testid="forgot-success">
            <MailCheck className="w-12 h-12 text-[#A78BFA] mx-auto mb-4" />
            <h1 className="font-['Outfit'] font-bold text-xl mb-2">Email Sent</h1>
            <p className="text-zinc-400 text-sm">If the account exists, a reset link has been sent to your email (valid for 30 minutes).</p>
          </div>
        ) : (
          <>
            <h1 className="font-['Outfit'] font-bold text-xl mb-2">Password Reset</h1>
            <p className="text-zinc-500 text-sm mb-6">Enter your admin email and we'll send a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
              <div className="space-y-2">
                <Label htmlFor="forgot-email" className="text-zinc-300">Email</Label>
                <Input
                  id="forgot-email" type="email" data-testid="forgot-email-input"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="bg-black/40 border-white/15 h-11 rounded-xl focus-visible:ring-[#A78BFA]" required
                />
              </div>
              <button
                type="submit" disabled={loading} data-testid="forgot-submit-button"
                className="w-full rounded-full bg-[#A78BFA] text-black font-bold py-3 hover:bg-[#fbbf24] transition-colors active:scale-95 disabled:opacity-60 flex items-center justify-center gap-2"
              >
                {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send Reset Link
              </button>
            </form>
          </>
        )}
        <div className="mt-5 text-center">
          <Link to="/admind" className="text-xs text-zinc-500 hover:text-[#A78BFA] transition-colors" data-testid="back-to-login-link">Back to login</Link>
        </div>
      </motion.div>
    </div>
  );
}
